// Compact "sort by" control for the ranked chart/list widgets: a
// metric picker (SegmentedControl) plus a direction toggle. Pair it
// with useChartSort -- pass the hook's return value straight through.
import React from 'react'
import { IconSortAscending, IconSortDescending } from '@tabler/icons-react'

import { SegmentedControl } from '@/components/buttons/SegmentedControl'
import { Button } from '@/components/buttons/Button'

export const ChartSortControl = ({ sort }) => {
  const { options, sortKey, sortDir, setMetric, toggleDir } = sort
  const items = options.map((option) => ({
    accessor: option.key,
    label: option.label,
    active: option.key === sortKey,
    onClick: () => setMetric(option.key),
    dataTestId: `chart-sort-${option.key}`,
  }))
  const ascending = sortDir === 'asc'
  return (
    <div className="chart-sort-control">
      <span className="chart-sort-control-label">Sort by</span>
      <SegmentedControl items={items} small />
      <Button
        square
        small
        onClick={toggleDir}
        tooltip={ascending ? 'Ascending' : 'Descending'}
        aria-label={ascending ? 'Sort ascending' : 'Sort descending'}
        data-testid="chart-sort-direction"
      >
        {ascending ? <IconSortAscending /> : <IconSortDescending />}
      </Button>
    </div>
  )
}
